import get from 'lodash/object/get'

const getStyledColor = path => p =>
  get(p.theme.colors, path, path)

export default getStyledColor
